import {useContext, useState} from "preact/hooks";
import {signInWithPopup} from "firebase/auth";
import {auth, createGoogleProvider} from "../includes/firebase.js";
import {NotificationContext} from "./NotificationContext.jsx";
import {useLocation} from "../hooks/useLocation.js";
import {GoogleOneTapClient} from "./GoogleOneTapClient.jsx";
import {postLoginTarget} from "../includes/redirect.js";
import {RingSpinner} from "./Spinner.jsx";

export function GoogleAuthButton({email = "", disabled, label}) {
    const location = useLocation();
    const {addNotification} = useContext(NotificationContext);
    const [loading, setLoading] = useState(false);

    const onGoogleAuth = async () => {
        setLoading(true);
        await signInWithPopup(auth, createGoogleProvider(email))
            .then(() => {
                location.route(postLoginTarget())
            })
            .catch((error) => {
                addNotification(error.message, "error");
            })
            .finally(() => {
                setLoading(false);
            });
    };

    return (
        <>
            <GoogleOneTapClient disabled={disabled || loading} />

            <div className="relative mb-4">
                <div className="absolute inset-0 flex items-center">
                    <div className="w-full border-t border-gray-700"></div>
                </div>
                <div className="relative flex justify-center text-xs">
                    <span className="bg-zinc-800 px-2 text-gray-400">or continue with</span>
                </div>
            </div>

            <button
                type="button"
                onClick={onGoogleAuth}
                disabled={disabled || loading}
                className="w-full mb-4 cursor-pointer text-white border border-gray-400 hover:bg-white hover:text-black font-medium rounded-lg text-sm px-5 py-2.5 text-center disabled:cursor-not-allowed disabled:text-gray-400 disabled:border-gray-700 disabled:opacity-70 inline-flex items-center justify-center gap-2"
            >
                <svg aria-hidden="true" width="18" height="18" viewBox="0 0 48 48">
                    <path fill="#FFC107"
                          d="M43.611 20.083H42V20H24v8h11.303C33.654 32.657 29.226 36 24 36c-6.627 0-12-5.373-12-12s5.373-12 12-12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.278 4 24 4C12.955 4 4 12.955 4 24s8.955 20 20 20s20-8.955 20-20c0-1.341-.138-2.65-.389-3.917z"/>
                    <path fill="#FF3D00"
                          d="M6.306 14.691l6.571 4.819C14.655 15.108 18.961 12 24 12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.278 4 24 4C16.318 4 9.656 8.337 6.306 14.691z"/>
                    <path fill="#4CAF50"
                          d="M24 44c5.176 0 9.86-1.977 13.409-5.192l-6.19-5.238C29.144 35.091 26.711 36 24 36c-5.205 0-9.619-3.317-11.283-7.946l-6.522 5.024C9.505 39.556 16.227 44 24 44z"/>
                    <path fill="#1976D2"
                          d="M43.611 20.083H42V20H24v8h11.303c-.792 2.238-2.231 4.166-4.084 5.57c.001-.001 6.19 5.238 6.19 5.238C36.971 39.205 44 34 44 24c0-1.341-.138-2.65-.389-3.917z"/>
                </svg>

                {label}

                {loading && <RingSpinner/>}
            </button>
        </>
    );
}
